import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

import { ConfigService } from './config.service';
import { AuthService } from './auth.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  private config = inject(ConfigService);
  private authService = inject(AuthService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.url === '/api/logout' || request.url.startsWith('/api/login')) {
      return next.handle(request);
    }
    // append the non-auth0 token if it exists
    if (!this.config.isAuth0Enabled() && this.authService.isLoggedIn) {
      request = request.clone({
        setHeaders: {
          Authorization: this.authService.getBasicToken(),
        },
      });
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const staleTokenStillStored = this.authService.getBearerToken().length > 0;
          if (staleTokenStillStored) {
            this.authService.logout();
          }
        }
        throw error;
      }),
    );
  }
}
